import React, { useEffect, useState } from "react";
import SearchBar from "../../../common/components/FormFields/SearchBar";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Tooltip } from "@mui/material";
import {
  doctorDropdown,
  fetchAllVisitList,
  searchVisitList,
} from "../../services/patientappointmentservices/PatientVisitListServices";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";

import { EMRIcon, PreAssessmentIcon } from "../../../assets/CommonAssets";
import PreAssessmentModal from "./PreAssessmentModal";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import EmrTemplate from "../emrTemplate/EmrTemplate";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { format } from "date-fns";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import GynacEmr from "../gynacemr/GynacEmr";
import GynecologyEmr from "../gynacemr/GynecologyEmr";
import EmrLiteNew from "../EmrLiteNewTest/EmrLiteNew";
import DentalEmr from "../newDentalEmr/components/DentalEmr";
import DentalEmrModal from "../newDentalEmr/components/DentalEmr";
// import EmrLite from "../EmrLite/EmrLite"

const removeHeaders = [
  "Id",
  "PatientId",
  "Cabin",
  "Authority Name",
  "PoliceStation",
  "VisitId",
  "WaitingTime",
  "isDeath",
  "MLC No",
  "BodyHandOverDate",
  "BodyHandOverTime",
  "GenderId",
  "mlcDetails",
  "EmergencyId",
  "AuthorutyBuckleNo",
  "BodyHandOverBuckelNo",
  "BodyHandOverPoliceStation",
  "cmoHandingOverBody",
  "Reporting Date",
  "Reporting Time",
  "mlcTypeId",
  "broughtBy",
  "BodyHandOver Time",
  "BodyHandOver Date",
  "mlcType",
  "TariffId",
  "UnitId",
  "MLCId",
  "GenderId",
  "TariffId",
  "PatientCatagoryId",
  "PatientSourceId",
  "CompanyId",
  "DepartmentId",
  "Doctor Id",
];

function PatientQueue() {
  const location = useLocation();
  const token = JSON.parse(localStorage.getItem("userInfo"));
  const schema = yup.object().shape({});
  const defaultValues = {
    doctor:
      !token.userRoles.includes("Super Admin") && token?.doctorId
        ? {
            id: token?.doctorId,
            label: token?.doctorName,
            value: token?.doctorName,
          }
        : null,
  };

  const {
    control,
    reset,
    register,
    watch,
    setValue,
    formState: {},
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues,
  });

  const [options, setOptions] = React.useState([]);
  const [loadingSpinner, setLoadingSpinner] = React.useState(false);
  const [dataResult, setDataResult] = React.useState([]);
  const [doctor, setDoctor] = useState();
  const [searchString, setSearchString] = React.useState("");
  const [userActions, setUserActions] = React.useState([]);
  const [openEmrModal, setOpenEmrModal] = React.useState(false);
  const [openDentalEmr, setOpenDentalEmr] = React.useState(false);
  const [openTemplateModal, setOpenTemplateModal] = React.useState(false);
  const [selectedRow, setselectedRow] = React.useState(null);
  const [openAssessmentModal, setOpenAssessmentModal] = useState(false);
  const [openEMrBackdrop, setOpenEMrBackdrop] = useState(false);
  const [openGynecologyEmr, setOpenGynecologyEmr] = React.useState(false);

  const handleCloseDentalEmr = () => {
    if (openDentalEmr === true) {
      setOpenDentalEmr(false);
    }
  };

  const handleCloseGynecologyEmr = () => {
    if (openGynecologyEmr === true) {
      setOpenGynecologyEmr(false);
    }
  };
  const navigate = useNavigate();

  let doctorVal = watch("doctor");

  console.log("locationEMR", location);

  useEffect(() => {
    let listObj = {
      cabin: null,
      doctorId: doctorVal ? doctorVal.id : null,
      fromDate: new Date(),
      menuId: location?.state?.menuId,
      page: 0,
      searchId: searchString?.id ? searchString?.id : "",
      searchString: "",
      size: 25,
      toDate: new Date(),
      unitId: null,
    };

    setLoadingSpinner(true);
    fetchAllVisitList(listObj)
      .then((response) => response.data)
      .then((res) => {
        setUserActions(res.actions);
        setDataResult(res.result);
        setLoadingSpinner(false);
      })
      .catch(() => {
        setLoadingSpinner(false);
      });
  }, [searchString, doctorVal]);

  function handleChange(searchString) {
    let searchObj = {
      doctorId: doctorVal ? doctorVal.id : null,
      fromDate: new Date(),
      searchString: searchString,
      toDate: new Date(),
    };
    searchVisitList(searchObj)
      .then((response) => response.data)
      .then((res) => {
        setOptions(res?.result);
      })
      .catch((error) => error);
  }

  function autoSelectedValue(selectedValue) {
    if (selectedValue !== "") {
      setSearchString(selectedValue);
    } else if (selectedValue === null) {
      setSearchString("");
    }
  }

  const getDoctorDropdownList = (searchDoctorString) => {
    if (searchDoctorString !== "") {
      doctorDropdown(searchDoctorString)
        .then((response) => response.data)
        .then((res) => {
          if (searchDoctorString !== null) {
            setDoctor(res.result);
          }
        });
    }
  };

  //   {
  //     "PatientId": 74,
  //     "MRNo": "970",
  //     "Patient Name": "Mr. SANGAM  PARANJPE",
  //     "Date": "05-02-2026 11:55 AM",
  //     "Doctor Id": 40960,
  //     "Doctor Name": "Dr.Swapneel Sayajirao Patil",
  //     "Medico Legal Case": false,
  //     "Token No": "0",
  //     "WaitingTime": "11:55",
  //     "Cabin": "Dialysis",
  //     "VisitId": 3093720,
  //     "Gender": "Male",
  //     "AgeYear": 46,
  //     "Reporting Date": null,
  //     "Reporting Time": null,
  //     "PoliceStation": null,
  //     "Authority Name": null,
  //     "AuthorutyBuckleNo": null,
  //     "MLC No": null,
  //     "mlcTypeId": null,
  //     "mlcType": null,
  //     "BodyHandOverDate": null,
  //     "BodyHandOverTime": null,
  //     "broughtBy": null,
  //     "isDeath": null,
  //     "mlcDetails": null,
  //     "BodyHandOverBuckelNo": null,
  //     "BodyHandOverPoliceStation": null,
  //     "cmoHandingOverBody": null,
  //     "GenderId": 2,
  //     "TariffId": 2,
  //     "PatientCatagoryId": 2,
  //     "PatientSourceId": 3,
  //     "CompanyId": 0,
  //     "UnitId": 2,
  //     "Department": "Gynecology & Obstetrics",
  //     "DepartmentId": 109,
  //     "EmergencyId": 0,
  //     "MLCId": null
  // }

  const handleEmrModalOpen = (row) => {
    // if (
    //   row?.Department?.toLowerCase() === "gynecology & obstetrics" ||
    //   row?.Department?.toLowerCase() === "gynecology and obstetrics"
    // ) {
    //   // setOpenGynecologyEmr(true);
    // } else if (row?.Department?.toLowerCase() === "dental") {
      setselectedRow(row);
      setOpenDentalEmr(true);
    // } else {
    //   // setOpenEMrBackdrop(true);
    //   setTimeout(() => {
    //     setselectedRow(row);
    //     setOpenEmrModal(true);
    //   }, 100);
    // }
  };

  const renderActions = (row, index) => {
    return (
      <div className="flex gap-2 w-full items-center cursor-pointer">
        {userActions &&
          userActions.map((actions, i) => (
            <>
              {actions.isAction === true ? (
                <>
                  <div className="flex items-center cursor-pointer">
                    {actions.action === "EMR" ? (
                      <>
                        <Tooltip title="EMR">
                          <button
                            onClick={() => {
                              handleEmrModalOpen(row);
                            }}
                          >
                            <EMRIcon />
                          </button>
                        </Tooltip>
                      </>
                    ) : (
                      ""
                    )}
                    {actions.action === "Pre Assessment" ? (
                      <>
                        <Tooltip title="Pre Assessment">
                          <button
                            type="button"
                            onClick={() => {
                              setOpenAssessmentModal(true);
                              setselectedRow(row);
                            }}
                          >
                            <PreAssessmentIcon />
                          </button>
                        </Tooltip>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : null}
            </>
          ))}
      </div>
    );
  };

  const renderInput = (row, index, header) => {
    return <></>;
  };

  return (
    <div className="mt-10 mx-auto w-full">
      <div className="py-2">
        <p className="font-semibold text-center text-2xl text-gray-700 font-Poppins">
          Patient Queue
        </p>
      </div>
      <div className="grid gap-2 md:grid-cols-4 p-1">
        <SearchBar
          searchIcon={true}
          isClearable={true}
          name="searchPatientName"
          placeholder="Search by Name / MR No."
          dataArray={options}
          isSearchable={true}
          handleInputChange={handleChange}
          onChange={autoSelectedValue}
        />
        {token?.doctorId === null && (
          <SearchDropdown
            control={control}
            name="doctor"
            placeholder="Doctor"
            label="Doctor"
            isSearchable={true}
            searchIcon={true}
            isClearable={true}
            dataArray={doctor}
            handleInputChange={getDoctorDropdownList}
            isDisabled={!token.userRoles.includes("Super Admin")}
          />
        )}

        <div className="col-start-4 flex justify-end">
          {userActions &&
            userActions.map((actions, i) => (
              <>
                {actions.isAction === false ? (
                  <>
                    <div className="flex gap-1 items-center cursor-pointer">
                      {actions.action === "EMR Templates" && (
                        <CommonButton
                          type="button"
                          className="bg-customBlue text-white "
                          label={"Template"}
                          onClick={() => {
                            setOpenTemplateModal(true);
                          }}
                        />
                      )}
                    </div>
                  </>
                ) : null}
              </>
            ))}
        </div>
      </div>

      {loadingSpinner ? (
        <div className="grid justify-center items-center pt-12">
          <LoadingSpinner />
        </div>
      ) : null}

      {dataResult.length > 0 && loadingSpinner === false ? (
        <CommonDynamicTableNew
          dataResult={dataResult}
          highlightRow={false}
          renderActions={renderActions}
          renderInput={renderInput}
          removeHeaders={removeHeaders}
        />
      ) : (
        !loadingSpinner && (
          <h1 className="flex justify-center items-center h-96 py-5 font-bold text-gray-600">
            No Record Found...
          </h1>
        )
      )}

      <CommonBackDrop openBackdrop={openEMrBackdrop} />

      {openEmrModal && (
        <EmrLiteNew
          openEmrModal={openEmrModal}
          close={() => {
            setOpenEmrModal(false);
          }}
          selectedRow={selectedRow}
          setOpenEMrBackdrop={setOpenEMrBackdrop}
        />
      )}
      {/* {openDentalEmr && (
        <div className="popup-backdrop">
          <div className="popup">
            <DentalEmr
              patient={selectedRow}
              visitId={selectedRow?.visitId}
              onClose={handleCloseDentalEmr}
              onSaved={(e) => console.log("saved", e)}
            />
          </div>
        </div>
      )} */}

      {openDentalEmr && (
        <DentalEmrModal
          open={openDentalEmr}
          visit={{ ...selectedRow, VisitId: selectedRow?.VisitId }}
          onClose={handleCloseDentalEmr}
          onSaved={(e) => console.log("saved", e)}
        />
      )}
      {/* {openEmrModal && (
        <EmrLite
          openEmrModal={openEmrModal}
          close={() => {
            setOpenEmrModal(false);
          }}
          selectedRow={selectedRow}
          setOpenEMrBackdrop={setOpenEMrBackdrop}
        />
      )} */}
      {openGynecologyEmr === true ? (
        <GynecologyEmr
          open={openGynecologyEmr}
          close={handleCloseGynecologyEmr}
        />
      ) : (
        ""
      )}
      {openAssessmentModal && (
        <PreAssessmentModal
          open={openAssessmentModal}
          close={() => setOpenAssessmentModal(false)}
          selectedPreAssessment={selectedRow}
        />
      )}
      {openTemplateModal && (
        <EmrTemplate
          open={openTemplateModal}
          close={() => setOpenTemplateModal(false)}
        />
      )}
    </div>
  );
}

export default PatientQueue;
